import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('VehicleType-index-1992f2b8c75612e7b-1'),
    routerUrl: '/VehicleType',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./VehicleType')),
    children: [
      //$MORE$
    ],
  },
];
